// Component Styles
const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
})

export default styles
